import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/mangaData';

export default function LatestUpdates() {
  const sorted = [...mangaList].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, 8);

  return (
    <section className="w-full py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-100 font-heading">最新更新</h2>
            <p className="text-sm text-foreground-500 mt-1">每日更新，精彩不间断</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap flex items-center gap-1"
          >
            全部更新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {sorted.map((manga) => (
            <Link
              key={manga.id}
              to={`/article/${manga.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                <img
                  src={manga.cover}
                  alt={manga.title}
                  title={`${manga.title} - h漫画最新更新`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2">
                  <span className="bg-primary-500 text-background-50 text-xs px-2 py-1 rounded whitespace-nowrap">NEW</span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-200 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
                {manga.title}
              </h3>
              <div className="flex items-center justify-between mt-1">
                <span className="text-xs text-foreground-600">{manga.author}</span>
                <span className="text-xs text-accent-500">{manga.updateDate}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}